import { fetchWrapper, getAuthenticatedRequest } from "../../utils/API/api.ts";
import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  USER_DETAILS_SUCCESS,
  USER_DETAILS_FAIL,
  USER_DETAILS_REQUEST,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_REQUEST,
  USER_UPDATE_FAIL,
  USER_EVENTS_SUCCESS,
  USER_EVENTS_REQUEST,
  USER_EVENTS_FAIL,
  USER_EVENTS_EMPTY,
} from "../constants/userConstants";
import { showToast } from "./toastActions.js";

// LOGIN ACTION
export const login =
  ({
    email,
    firstName,
    lastName,
    mobile,
    organization,
    jobTitle,
    linkedinAccessToken,
  }) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: USER_LOGIN_REQUEST });

      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT_LEADS}/user/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email,
            firstName,
            lastName,
            mobile,
            organization,
            jobTitle,
            linkedinAccessToken: linkedinAccessToken
              ? linkedinAccessToken
              : null,
          }),
          credentials: "include",
        }
      );

      const data = await response.json();

      if (data.message) {
        throw new Error("invalid email");
      }

      // localStorage.setItem("accessToken", data.accessToken);
      localStorage.setItem("refreshToken", data?.refreshToken);

      if (data.newUser?.firstName) {
        dispatch({
          type: USER_LOGIN_SUCCESS,
          payload: {
            ...data.newUser,
            accessToken: data.accessToken,
          },
        });
      } else {
        dispatch({
          type: USER_LOGIN_SUCCESS,
          payload: {
            ...data.oldUser,
            accessToken: data.accessToken,
          },
        });
      }

      // localStorage.setItem(
      //   "userInfo",
      //   JSON.stringify(getState().userLogin.userInfo)
      // );
      // localStorage.setItem(
      //   "user",
      //   data.newUser
      //     ? JSON.stringify(data.newUser)
      //     : JSON.stringify(data.oldUser)
      // );
      // if (data.newUser?.firstName) {
      //   if (data.newUser.organizer?.events.length === 0) {
      //     router.push("/login/demoevent");
      //   }
      // }
    } catch (err) {
      dispatch({
        type: USER_LOGIN_FAIL,
        payload: err.message,
      });
    }
  };

// LOGOUT ACTION
export const logout = () => async (dispatch) => {
  try {
    await fetch(`${process.env.REACT_APP_SERVER_URL_LEADS}/user/logout`, {
      method: "POST",
      credentials: "include",
    });

    localStorage.removeItem("userInfo");

    dispatch({ type: USER_LOGOUT });
    window.location.pathname = "/login";
  } catch (err) {
    dispatch(
      showToast({
        message: `Something went wrong, please try again later`,
        category: "danger",
      })
    );
  }
};

// GET USER DETAILS;
export const getUserDetails = () => async (dispatch, getState) => {
  try {
    dispatch({ type: USER_DETAILS_REQUEST });
    const response = await getAuthenticatedRequest(`/user`);

    const data = response?.data;

    if (data.error) {
      throw new Error(data.error);
    }

    dispatch({
      type: USER_DETAILS_SUCCESS,
      payload: {
        ...data,
      },
    });

    // dispatch({ type: USER_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: USER_DETAILS_FAIL, payload: error.message });
  }
};

//USER UPDATE ACTIONS
export const updateUserProfile = (user) => async (dispatch, getState) => {
  try {
    dispatch({ type: USER_UPDATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const response = await fetch("/api/users/profile", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userInfo.token}`,
      },
      body: JSON.stringify(user),
    });

    const data = await response.json();

    if (data.message) {
      throw new Error(data.message);
    }

    dispatch({ type: USER_UPDATE_SUCCESS, payload: data });
    // i am doing this change for a bug in ...
    dispatch({ type: USER_DETAILS_SUCCESS, payload: data });
    localStorage.setItem("userInfo", JSON.stringify(data));
  } catch (error) {
    dispatch({ type: USER_UPDATE_FAIL, payload: error });
  }
};

//USER GET ALL USER-EVENTS
export const getUserEvents =
  ({ accessToken, tab, page }) =>
  async (dispatch) => {
    try {
      dispatch({ type: USER_EVENTS_REQUEST });

      let url = `/user/events?page=${page}`;
      if (tab) {
        url = `/user/events?filter=${tab?.toLowerCase()}&page=${page}`;
      }
      const response = await getAuthenticatedRequest(url);

      // const response = await fetch(
      //   `${process.env.REACT_APP_SERVER_URL}${url}`,
      //   {
      //     method: "GET",
      //     headers: {
      //       Authorization: `bearer ${accessToken}`,
      //     },
      //   }
      // );

      const data = response?.data;

      if (data.message) {
        throw new Error("invalid req in getUserEvents");
      }

      dispatch({
        type: USER_EVENTS_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: USER_EVENTS_FAIL,
        payload: err.message,
      });
    }
  };
